((angular) => {
    'use strict';

    angular.module('wtUi.wtListDataTable', [
        'ui.bootstrap.tooltip',
        'wtUi.wtToggleSwitch'
    ]);
})(window.angular);
